module.exports = __webpack_public_path__ + "static/media/layer-group.0d716412.svg";